// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./styles/style.scss
// module id = 36
// module chunks = 1